module.exports = __webpack_public_path__ + "static/apparatus_of_kwalish-97e6f1f43777cc6d66b410e6766e3f71.jpeg";